import React from "react";

export default function ActionButton(props) {
    const newProps = { ...props };
    delete newProps.isLoading;
    newProps.className = "className" in props ? props.className + " btn btn-primary btn-sm" : "btn btn-primary btn-sm";
    return <button { ...newProps }>{ props.children }
        { props.isLoading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span> }
    </button>
}